import React from 'react';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import IntlMessages from 'util/IntlMessages';
import { getDateLocale } from '../../util/utilFunction';
import config from '../../config';

const NotificationItem = ({notification,selectedReplyMessage,selectedReadMessage}) => {
  const { badge, createDate, body, senderUser, senderUserImage} = notification;
  const image = senderUserImage ? (config.userAuthApiUrl + senderUserImage) : '';
  const senderName = senderUser || 'Tanımsız Kullanıcı';
  return (
    <li className="media"> 
      <div className="user-avatar">
        <Avatar
          alt={senderName} 
          src={image}
        />
        <span className="badge badge-danger rounded-circle">{badge}</span>
      </div>
      <div className="media-body">
        <div className="d-flex justify-content-between align-items-center">
          <h5 className="text-capitalize user-name mb-0"><span className="jr-link" onClick={()=>selectedReplyMessage(notification)}>{senderName}</span></h5>
          <span className="meta-date"><small>{getDateLocale(createDate)}</small></span>
        </div>
        <p className="sub-heading">{body ? body.substring(0, 25) + "..." : ""}</p>
        <Button className="jr-btn jr-btn-xs text-muted" onClick={()=>selectedReplyMessage(notification)}><i className="zmdi zmdi-mail-reply"/><span><IntlMessages id="button.reply"/></span></Button>
        <Button className="jr-btn jr-btn-xs text-muted" onClick={()=>selectedReadMessage(notification)}><i className="zmdi zmdi-eye"/><span><IntlMessages id="button.read"/></span></Button>
      </div>
    </li>
  );
};

export default NotificationItem;
